import React, { useMemo } from 'react';
import { Outlet, useLocation } from 'react-router';

import HeaderNav from '@components/Header/HeaderNav';
import { TurnstileSlotProvider } from '@components/Turnstile/TurnstileSlot';
import { ROUTES } from '@constants/routes';
import { useHeaderHeight } from '@hooks/useHeaderHeight';

import { useOrderContext } from './hooks/useOrderContext';
import type { OrderRouteContext } from './types/Order.types';

export const OrderLayout: React.FC = () => {
  const {
    partnerConfig,
    partner,
    state: { external_member_id },
  } = useOrderContext();
  const { pathname } = useLocation();
  const isWizardRoute = pathname.endsWith(ROUTES.ORDER_WIZARD);
  const hideLogin = isWizardRoute;
  const partnerLogoSrc = partnerConfig?.logoUrl
    ? partnerConfig.logoUrl
    : partnerConfig?.logoFileName
      ? `/partners/${partnerConfig.logoFileName}`
      : undefined;

  // Derive campaignCode from partnerConfig for partnership routes
  const campaignCode = partnerConfig?.campaignCode;

  const routeContext: OrderRouteContext = useMemo(
    () => ({
      isPartnershipRoute: !!partner,
      isOrderRoute: !partner,
      partner,
      campaignCode,
    }),
    [partner, campaignCode],
  );
  const headerHeight = useHeaderHeight();

  return (
    <TurnstileSlotProvider>
      <HeaderNav partnerLogoSrc={partnerLogoSrc} external_member_id={external_member_id} noLoginButton={hideLogin} />
      <div
        className='partner-order-layout'
        style={{ '--partner-order-header-height': `${headerHeight}px` } as React.CSSProperties}
      >
        <Outlet context={routeContext} />
      </div>
    </TurnstileSlotProvider>
  );
};
